
import { Component, ViewChild, AfterViewInit, ChangeDetectionStrategy } 		 from '@angular/core';

@Component({
  selector: 'panel',
  standalone: true,
  inputs: ['title', 'variant', 'noBody', 'noButton', 'headerClass', 'bodyClass', 'footerClass', 'panelClass'],
  templateUrl: './panel.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})

export class PanelComponent implements AfterViewInit  {
  @ViewChild('panelFooter', { static: false }) panelFooter: any;
  expand = false; 
  reload = false;
  collapse = true;
  remove = false;
  showFooter = false;
  
  ngAfterViewInit() {
    setTimeout(() => {
      this.showFooter = (this.panelFooter) ? this.panelFooter.nativeElement && this.panelFooter.nativeElement.children.length > 0 : false;
    });
  }

  panelExpand() {
    this.expand = !this.expand;
  }
  panelReload() {
    this.reload = true;

    setTimeout(() => {
      this.reload = false;
    }, 1500);
  }
  panelCollapse() {
    this.collapse = !this.collapse;
  }
  panelRemove() {
    this.remove = !this.remove;
  }
}
